import { PlaceholderPage } from './PlaceholderPage';

export const ImportTemplatesReportsPage = () => <PlaceholderPage title="Import Templates & Reports" />;
